import { Quill } from 'react-quill';

const BlockEmbed = Quill.import('blots/block/embed');

class PageBreakBlot extends BlockEmbed {
  static create(value) {
    const node = super.create();
    node.classList.add('ql-pagebreak');
    node.classList.add('page-break');
    node.setAttribute('contenteditable', 'false');
    node.setAttribute('data-page-break', 'true');
    node.setAttribute('data-blot', 'pagebreak');
    node.style.pageBreakAfter = 'always';
    node.style.breakAfter = 'page';
    node.style.height = '4px';
    node.style.background = 'linear-gradient(90deg, transparent, #999 20%, #999 80%, transparent)';
    node.style.margin = '40px 0';
    node.style.borderTop = '2px dashed #666';
    node.style.borderBottom = '2px dashed #666';
    node.style.position = 'relative';
    node.style.display = 'block';
    node.style.width = '100%';
    node.style.clear = 'both';
    node.style.cursor = 'pointer';
    
    // Add visual indicator with delete button
    const span = document.createElement('span');
    span.textContent = 'Page Break';
    span.style.position = 'absolute';
    span.style.top = '-14px';
    span.style.left = '50%';
    span.style.transform = 'translateX(-50%)';
    span.style.background = 'white';
    span.style.padding = '2px 20px';
    span.style.color = '#666';
    span.style.fontSize = '12px';
    span.style.fontWeight = '600';
    span.style.textTransform = 'uppercase';
    span.style.letterSpacing = '1.5px';
    span.style.whiteSpace = 'nowrap';
    span.style.userSelect = 'none';
    span.style.border = '1px solid #ddd';
    span.style.borderRadius = '12px';
    span.style.display = 'flex';
    span.style.alignItems = 'center';
    span.style.gap = '10px';
    
    // Add delete button
    const deleteBtn = document.createElement('button');
    deleteBtn.innerHTML = '×';
    deleteBtn.style.background = '#ff4444';
    deleteBtn.style.color = 'white';
    deleteBtn.style.border = 'none';
    deleteBtn.style.borderRadius = '50%';
    deleteBtn.style.width = '18px';
    deleteBtn.style.height = '18px';
    deleteBtn.style.fontSize = '16px';
    deleteBtn.style.lineHeight = '1';
    deleteBtn.style.cursor = 'pointer';
    deleteBtn.style.padding = '0';
    deleteBtn.style.display = 'flex';
    deleteBtn.style.alignItems = 'center';
    deleteBtn.style.justifyContent = 'center';
    deleteBtn.title = 'Remove page break';
    deleteBtn.onclick = (e) => {
      e.stopPropagation();
      e.preventDefault();
      // Remove the page break from Quill
      const blot = Quill.find(node);
      if (blot && blot.scroll && blot.scroll.emitter && blot.scroll.emitter.emit) {
        // Emit a custom event that the page break is being deleted
        blot.scroll.emitter.emit('pagebreak-delete-start');
        
        // Get the Quill instance and delete using the proper API
        const quill = blot.scroll.quill;
        if (quill) {
          const index = quill.getIndex(blot);
          quill.deleteText(index, 1, 'silent');
        } else {
          blot.remove();
        }
        
        // Emit completion after a small delay
        setTimeout(() => {
          blot.scroll.emitter.emit('pagebreak-delete-end');
        }, 200);
      } else if (blot) {
        blot.remove();
      }
    };
    
    span.appendChild(deleteBtn);
    node.appendChild(span);
    
    // Add hover effect
    node.onmouseenter = () => {
      node.style.background = 'linear-gradient(90deg, transparent, #666 20%, #666 80%, transparent)';
      deleteBtn.style.background = '#ff0000';
    };
    
    node.onmouseleave = () => {
      node.style.background = 'linear-gradient(90deg, transparent, #999 20%, #999 80%, transparent)';
      deleteBtn.style.background = '#ff4444';
    };
    
    return node;
  }
  
  static value(node) {
    return true;
  }
  
  static formats(node) {
    return {};
  }
}

PageBreakBlot.blotName = 'pagebreak';
PageBreakBlot.tagName = 'div';
PageBreakBlot.className = 'page-break';

export default PageBreakBlot;